<template>
  <div class="recipient-address-box invoice-select-item" :class="{'selected': selected == address.id}" @click="selectItem">
    <el-form :model="addressForm" label-width="64px" size="mini" ref="addressForm" :rules="rules">
      <el-form-item label="收件人:" prop="receiverName">
        <el-input v-if="!address.id" v-model="addressForm.receiverName"></el-input>
        <span v-else>{{address.receiverName}}</span>
      </el-form-item>
      <el-form-item label="联系邮箱:" prop="email">
        <el-input v-if="!address.id" v-model="addressForm.email"></el-input>
        <span v-else>{{address.email}}</span>
      </el-form-item>
      <el-form-item label="联系电话:" prop="telNum">
        <el-input v-if="!address.id" v-model="addressForm.telNum"></el-input>
        <span v-else>{{address.telNum}}</span>
      </el-form-item>
      <el-form-item v-if="!address.id" class="address-select" label="所属区域:" prop="addressSelect">
        <el-form-item prop="addressProvince" label-width="0">
          <el-select v-model="addressForm.addressProvince">
            <el-option v-for="it in provinces" :key="it.value" :label="it.name" :value="it.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="addressCity" label-width="0">
          <el-select v-model="addressForm.addressCity">
            <el-option v-for="it in cities" :key="it.value" :label="it.name" :value="it.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="addressDistrict" label-width="0">
          <el-select v-model="addressForm.addressDistrict">
            <el-option v-for="it in districts" :key="it.value" :label="it.name" :value="it.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form-item>
      <el-form-item label="邮寄地址:" prop="addressDetail">
        <el-input v-if="!address.id" v-model="addressForm.addressDetail"></el-input>
        <span v-else>{{address.addressProvince}}{{address.addressCity}}{{address.addressDistrict}}{{address.addressDetail}}</span>
      </el-form-item>
    </el-form>
    <div class="action-box">
      <span>
        <i v-if="!address.id" class="el-icon-close" @click.stop="cancel"></i>
        <i v-if="!address.id" class="el-icon-check" @click.stop="save"></i>
        <i v-if="address.id" class="el-icon-delete" @click.stop="deleteAddress"></i>
      </span>
    </div>
  </div>
</template>
<script>
  import {deleteAddress, saveAddress} from '../utils/api.js';
  import Districts from './districts.js';
  const districtsConvert = function(d, name) {
    return [{name, value: ''}].concat(Object.keys(d).map(id => {
      return {name: d[id], value: id};
    }));
  }
  export default {
    name: 'shipping-address',
    props: {
      address: Object,
      selected: Number,
      index: Number
    },
    data() {
      return {
        addressForm: {
          receiverName: '',
          telNum: '',
          addressProvince: '',
          addressCity: '',
          addressDistrict: '',
          addressDetail: '',
          email: ''
        },
        provinces: districtsConvert(Districts[100000], '-省-'),
        cities: [{name: '-市-', value: ''}],
        districts: [{name: '-区-', value: ''}],
        rules: {
          receiverName: {
            validator: function(rule, value, callback) {
              if (!value || !value.trim()) {
                callback(new Error('请输入收件人'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
          telNum: {
            validator: function(rule, value, callback) {
              if (!value || !value.trim()) {
                callback(new Error('请输入联系电话'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
          email: {
            validator: function(rule, value, callback) {
              if (!value || !value.trim()) {
                callback(new Error('请输入联系邮箱'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
          addressDetail: {
            validator: function(rule, value, callback) {
              if (!value || !value.trim()) {
                callback(new Error('请输入邮寄地址'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
          addressSelect: {
            validator: (rule, value, callback) => {
              if (!this.addressForm.addressProvince) {
                callback(new Error('请选择省份直辖市'));
              } else if (!this.addressForm.addressCity) {
                callback(new Error('请选择城市'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        }
      }
    },
    computed: {
    },
    watch: {
      'addressForm.addressProvince': function(v) {
        if (v) {
          const cities = districtsConvert(Districts[v], '-市-');
          this.cities = cities;
        } else {
          this.cities = [{name: '-市-', value: ''}];
        }
        this.addressForm.addressCity = '';
      },
      'addressForm.addressCity': function(v) {
        if (v) {
          const districts = districtsConvert(Districts[v], '-市-');
          this.districts = districts;
        } else {
          this.districts = [{name: '-区-', value: ''}];
        }
        this.addressForm.addressDistrict = '';
      }
    },
    methods: {
      cancel() {
        this.$emit('delete', this.index);
      },
      deleteAddress() {
        this.$confirm(`确认要删除${this.address.receiverName}的收货人信息吗？`, '删除收货人', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let result = await deleteAddress({receiverId: this.address.id});
          if (result && result.success) {
            this.$message.success('操作成功');
            this.$emit('delete', this.index);
          }
        }).catch(() => {});
      },
      save() {
        this.$refs.addressForm.validate(async valid => {
          const addressProvince = Districts[100000][this.addressForm.addressProvince];
          const addressCity = Districts[this.addressForm.addressProvince][this.addressForm.addressCity];
          const addressDistrict = this.addressForm.addressDistrict ? Districts[this.addressForm.addressCity][this.addressForm.addressDistrict] : '';
          const params = {
            receiverName: this.addressForm.receiverName,
            receiverTelNum: this.addressForm.telNum,
            receiverEmail: this.addressForm.email,
            addressProvince,
            addressCity,
            addressDistrict,
            receiverAddressInput: this.addressForm.addressDetail,
            receiverAddressChosen: `${addressProvince}/${addressCity}/${addressDistrict}`,
          };
          let result = await saveAddress(params);
          if (result && result.receiverId) {
            this.$message.success('操作成功');
            this.$emit('save', this.index, Object.assign(this.addressForm, params, {id: result.receiverId}));
          }
        });
      },
      selectItem() {
        this.$emit('select', this.address);
      }
    }
  }
</script>
<style lang="scss">
  .recipient-address-box {
    width: 300px;
    .el-form-item__label {
      font-size: 12px;
    }
    .el-form-item--mini.el-form-item {
      margin-bottom: 12px;
    }
    .el-form-item .el-input{
      width: 100% !important;
    }
    .address-select {
      .el-form-item__content {
        font-size: 0;
      }
      .el-form-item {
        display: inline-block;
        width: 70px;
        margin-bottom: 0;
        &:nth-child(2) {
          margin: 0 2px;
        }
      }
    }
  }
</style>